import React, { useContext, useState } from 'react';
import AppEmojiIcons from '../../icons/emojiIcons';
import { AdminContext } from '../../context/AdminContext';
import AppIcons from '../../icons';
import Loader from '../Loader';
import styles from './styles.module.css';

const FileTypeComponent = ({
  children,
  path,
  type,
  item,
  downloadedFiles,
  setDownloadedFiles,
  chatBody = false,
  onClick,
  extraClassName = 'nothing',
  showName = false,
  extraNameStyle = 'nothing',
}) => {
  const [loading, setLoading] = useState(false);
  const { activeUser, isElectron } = useContext(AdminContext);

  const downloadFunction = (urlis, fileName, fileType) => {
    setLoading(true);
    let ddd = window.electron.ipcRenderer.sendMessage('download-file', {
      url: urlis,
      fileName: fileName,
      fileType: fileType,
      // filePath: '/desktop/file',
    });

    window.electron.ipcRenderer.once('files', (event) => {
      setDownloadedFiles(event);
      setLoading(false);
    });
  };
  const showLocationFunction = (urlis, fileName, fileType) => {
    let ddd = window.electron.ipcRenderer.sendMessage('fileLocation', {
      url: urlis,
      fileName: fileName,
      fileType: fileType,
      // filePath: '/desktop/file',
    });

    // window.electron.ipcRenderer.once('showLocation', (event) => {
    //   setDownloadedFiles(event);
    //   setLoading(false);
    // });
  };

  // console.log('chatbody', chatBody, type);
  console.log(
    'item===========',
    item
    // downloadedFiles?.findIndex((x) => x == item?.file?.name),
    // downloadedFiles
  );
  console.log('downloaded==', downloadedFiles);
  return (
    <>
      {item?.file?.fileExtension?.type == type && (
        <div
          className={`relative w-full ${styles.fileContainer} ${extraClassName} `}
          onClick={onClick}
        >
          {children}
          {/* {!chatBody && item?.chatPin?.length != 0 && item?.chatPin != undefined &&

<div className={`${styles.start} ${!chatBody && styles.fileSectionPosition}`}>
<AppEmojiIcons.StarFullIcon  width={"18px"} height={'18px'} fill={`#ffb700`}  className={`noFilterSvg`}/>
</div>
} */}
          {/* {favFunction != null && <div className={`${styles.removeFav}`} onClick={(e)=>{e.preventDefault();e.stopPropagation(); favFunction({id: item?.id, roomId: item?.roomId})}}>c</div>} */}
          <>
            {showName && (
              <>
                {chatBody && type == 'video' ? (
                  <p className={`${styles.absoluteName} ${extraNameStyle}`}>
                    {item?.name ? item?.name : item?.file?.name}
                  </p>
                ) : (
                  <p
                    className={`${styles.absoluteName}  ${extraNameStyle} ltr`}
                  >
                    {item?.name ? item?.name : item?.file?.name}
                  </p>
                )}
              </>
            )}
            {!chatBody && (
              <>
                {downloadedFiles?.findIndex((x) => x == item?.file?.name) ==
                -1 ? (
                  <>
                    {loading ? (
                      <div
                        className={`${styles.downloadIcon} mainBg cursor-default noFilterSvg`}
                      >
                        <Loader
                          className={'lds_ringWhite'}
                          width="w-[15px]"
                          height="h-[15px]"
                        />
                      </div>
                    ) : (
                      <>
                        {isElectron ? (
                          <AppIcons.DownloadIcon
                            className={`${styles.downloadIcon} noFilterSvg mainBg`}
                            onClick={(e) => {
                              e.stopPropagation();
                              window.electron &&
                                downloadFunction(
                                  `${path}${item?.file?.name}`,
                                  `${item?.file?.name}`,
                                  item?.file?.fileExtension?.type
                                );
                            }}
                          />
                        ) : (
                          <a
                            href={`${path}${item?.file?.name}`}
                            download
                            target="_blank"
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                            className={`${styles.downloadIcon} noFilterSvg mainBg flex flex-row justify-center items-center`}
                          >
                            <AppIcons.DownloadIcon
                              width={20}
                              height={20}
                              // className={`${styles.downloadIcon} noFilterSvg mainBg`}
                              // onClick={() => {
                              //   downloadFunction(
                              //     `${path}${item?.file?.name}`,
                              //     `${item?.file?.name}`,
                              //     item?.file?.fileExtension?.type
                              //   );
                              // }}
                            />
                          </a>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {isElectron && (
                      <AppIcons.LocationIcon
                        className={`${styles.locationIcon} noFilterSvg mainBg`}
                        onClick={(e) => {
                          e.stopPropagation();
                          window.electron &&
                            showLocationFunction(
                              `${path}${item?.file?.name}`,
                              `${item?.file?.name}`,
                              item?.file?.fileExtension?.type
                            );
                        }}
                      />
                    )}
                  </>
                )}
              </>
            )}
          </>
        </div>
      )}
    </>
  );
};
export default FileTypeComponent;
